<template>
  <div class="Site IndexBox" style="padding-top:0">
    <div class="ScrollBox">
      <div class="box-bg">
        <van-nav-bar
          :border="false"
          :title="$docTitle"
          style="background:transparent"
        >
        </van-nav-bar>
        <div class="user-grade">
          <div class="bg">
            <div class="left">
              {{$t('Partner[0]')}}{{UserInfo?UserInfo.crowdfunding_name:$t('Video[0][0]')}}
              <p>{{$t('Video[0][1]')}}</p>
            </div>
            <div v-if="UserInfo" class="right">
              <van-button color="var(--button-main)" plain round size="small" style="border:0;padding:0 15px;" @click="showPartner=true">{{$t('Partner[1]')}}</van-button>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
      <van-cell-group v-if="UserInfo.crowdfunding_grade" :title="$t('Video[2][0]')" :border="false">
        <van-cell class="income" :label="`${$t('Video[2][1]')} ${InitData.currency}${$Util.MoneyFormat(gradeInfo.commission)}`">
          <template #title>
            {{$Util.MoneyFormat(StatisticalData.c_today_earnings)}}<small>{{InitData.currency}}</small>
          </template>
          <template #extra>
            <van-button color="var(--button-main)" plain round size="mini" to="user/wallet">{{$t('Video[2][2]')}}</van-button>
          </template>
        </van-cell>
      </van-cell-group>
      <div v-if="taskInfo" class="task-item">
        <div class="info">
          <div class="progress">
            <div class="flex">
              {{$t('Video[3][0]')}}
              <b>{{StatisticalData.c_day_number}}</b>
            </div>
            <van-progress :percentage="StatisticalData.c_my_day_number?parseInt(StatisticalData.c_day_number/StatisticalData.c_my_day_number*100):0" color="var(--background-linear)" track-color="#d1d1d1" stroke-width="6" :show-pivot="false" />
            <div class="flex">
              {{$t('Video[3][1]')}}
              <div style="display:flex;align-items:center">
                <van-button v-if="UserInfo.is_key==1&&StatisticalData.c_today_s_o_num" color="var(--button-main)" round size="mini" style="margin-right: 15px" @click="submitAllVideo">{{$t('Video[10]')}}</van-button>
                <b>{{StatisticalData.c_today_s_o_num}}</b>
              </div>
            </div>
          </div>
          <div class="video">
            <a v-if="playStart" class="count-down" href="javascript:;" @click="countDown==0?player.pause():false">{{countDown==0?$t('Video[7]'):countDown}}</a>
            <video-player  
              class="vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              x5-playsinline
              webkit-playsinline
              :options="playerOptions"
              @ready="playerReadied"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
            />
            <van-popup class="down-popup" v-model="showDown" position="right" :overlay="false">
              <a href="javascript:;" @click="clickDown">
                <img :src="`./static/images/${$i18n.locale}/video-down.png`" width="100%" height="100%">
              </a>
            </van-popup>
          </div>
        </div>
        <div v-if="UserInfo" class="btn">
          <van-button color="var(--button-main)" round block style="font-size:16px" :disabled="StatisticalData.c_today_s_o_num?false:true" @click="openVideo(false)">{{$t('Video[4]')}}</van-button>
          <!-- <van-button color="var(--button-main)" plain round block style="font-size:16px;margin-top: 10px" @click="openVideo(true)">{{$t('Video[6]')}}</van-button> -->
        </div>
        <div v-else class="btn">
          <van-button color="var(--button-main)" plain round block style="font-size:16px" to="/login">{{$t('Video[5]')}}</van-button>
        </div>
        <van-tabs v-model="tabsIndex" class="partner-tabs" :ellipsis="false" :border="false" color="var(--color-active)" title-active-color="var(--color-active)" @change="changeTabs">
          <van-tab :title="$t('Partner[2][0]')">
            <div class="vip-list">
              <div v-for="item,index in InitData.UserCrowdfundingList" :key="index" :class="`item vip${(item.grade-2)%5}`">
                <span>{{item.name}}</span>
                <h3>{{$t('vip.top[1]')}}</h3>
                <div class="grid">
                  <div v-for="spread,i in item.spread.split(',')" :key="i">
                    {{spread}}%
                    <p>{{$t(`vip.top[2][${i}]`)}}</p>
                  </div>
                </div>
                <div class="bottom">
                  <div class="money">
                    {{$t('vip.top[3][0]')}}: <b>{{item.amount}} ({{InitData.currency}})</b>
                    <a href="javascript:;" @click="detailInfo=item,showDetail=true">{{$t('vip.top[3][1]')}}
                    <van-icon name="arrow" /></a>
                  </div>
                  <div class="btn">
                    <van-button color="linear-gradient(#fee6b2,#fab675)" round size="mini" style="border:0;padding:0 15px" @click="showPartnerAdd=true,formData.grade=item.grade,radioGrade=item.grade,gradeData=item">{{$t('Partner[2][0]')}}</van-button>
                    <van-button color="linear-gradient(#fee6b2,#fab675)" round size="mini" style="border:0;padding:0 15px;margin-top: 10px" @click="showRule=true,ruleInfo=item.rule">{{$t('Partner[10]')}}</van-button>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab :title="$t('Partner[2][1]')">
            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
              <van-list
                v-model="isLoad"
                :finished="isFinished"
                :finished-text="joinData.length?$t('vanPull[0]'):$t('vanPull[1]')"
                @load="onLoad"
                :class="{Empty:!joinData.length}"
              >
                <van-cell class="item" v-for="(item,index) in joinData" :key="index" :border="false">
                  <template #title>
                    {{$t('Partner[9][0]')}}:{{item.username}}
                    <p style="margin-top: 5px">{{item.title}}</p>
                  </template>
                  <template #label>
                    <p>{{$t('Partner[9][1]')}}:{{item.name}}</p>
                    <p>{{$t('Partner[9][2]')}}:{{item.y_copies}} / {{item.all_copies}}</p>
                    <p>{{$t('Partner[9][9]')}}:{{item.create_time}}</p>
                  </template>
                  <template #extra>
                    <div class="right">
                      <div class="price">
                        <p>{{$t('Partner[9][3]')}}</p>
                        <b>{{InitData.currency}}{{item.per_amount}}</b>
                      </div>
                      <div v-if="item.state==1">
                        <img class="state" :src="`./static/icon/${$i18n.locale}/state3.png`">
                      </div>
                      <div v-else>
                        <van-button type="danger" size="mini" round @click.stop="showJoin=true,joinForm.cid=item.id,currPartner=item">{{$t('Partner[9][8]')}}</van-button>
                      </div>
                    </div>
                  </template>
                </van-cell>
              </van-list>
            </van-pull-refresh>
          </van-tab>
          <van-tab :title="$t('Partner[2][2]')">
            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
              <van-list
                v-model="isLoad"
                :finished="isFinished"
                :finished-text="myData.length?$t('vanPull[0]'):$t('vanPull[1]')"
                @load="onLoad"
                :class="{Empty:!myData.length}"
              >
                <van-cell class="item" v-for="(item,index) in myData" :key="index" :border="false">
                  <template #title>
                    {{$t('Partner[9][0]')}}:{{item.cusername}}
                    <p style="margin-top: 5px">{{item.title}}</p>
                  </template>
                  <template #label>
                    <p>{{$t('Partner[9][1]')}}:{{item.name}}</p>
                    <p>{{$t('Partner[9][2]')}}:{{item.y_copies}} / {{item.all_copies}}</p>
                    <p>{{$t('Partner[9][9]')}}:{{item.create_time}}</p>
                  </template>
                  <template #extra>
                    <div v-if="item.state==2" class="right">
                      <div class="price">
                        <p>{{$t('Partner[9][3]')}}</p>
                        <b>{{InitData.currency}}{{item.per_amount}}</b>
                      </div>
                      <div style="display:flex;align-items:center">
                        {{$t('Partner[9][4]')}}:{{item.my_copies}}{{$t('Partner[9][5]')}}
                        <van-button type="danger" size="mini" round @click.stop="showJoin=true,joinForm.cid=item.cid,currPartner=item">{{$t('Partner[9][6]')}}</van-button>
                      </div>
                    </div>
                    <div v-else class="right">
                      <div class="price">
                        {{$t('Partner[9][7]')}}:<b style="display:inline-block">{{InitData.currency}}{{$Util.MoneyFormat(item.profit)}}</b>
                      </div>
                      <div>{{$t('Partner[9][3]')}}:{{InitData.currency}}{{item.per_amount}}</div>
                      <div class="mt8">{{$t('Partner[9][4]')}}:{{item.my_copies}}{{$t('Partner[9][5]')}}</div>
                    </div>
                  </template>
                </van-cell>
              </van-list>
            </van-pull-refresh>
          </van-tab>
        </van-tabs>
      </div>
      <van-loading v-else size="60px" vertical style="margin-top: 20%">{{$t('task.show[13]')}}</van-loading>
    </div>
    <Footer />
    <van-popup v-model="showVideo" close-on-popstate :close-on-click-overlay="false" :overlay-style="{'background-color':'rgba(0,0,0,.9)'}" style="height:100%;width:100%;background:transparent" @opened="openedVideo" @close="closeVideo">
      <a v-if="countDown==0" class="count-down" href="javascript:;" @click="showVideo=false">{{$t('Video[7]')}}</a>
      <a v-else class="count-down" href="javascript:;">{{countDown}}</a>
      <video-player  
        class="vjs-custom-skin"
        ref="fullPlayer"
        :playsinline="true"
        :options="fullOptions"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
      />
    </van-popup>
    <van-action-sheet v-model="showPartner" :title="$t('Partner[1]')" :actions="partnerActions" :closeable="false" @select="onSelect" />
    <van-action-sheet v-model="showPartnerAdd" :title="$t('Partner[2][0]')" :closeable="false" @closed="resetForm">
      <van-form @submit="onSubmitAdd">
        <van-field
          v-model="formData.grade"
          name="grade"
          :label="$t('Partner[3][0]')"
          :placeholder="$t('Partner[3][1]')"
          :rules="[{ required: true, message: $t('Partner[3][1]') }]"
          size="large"
          readonly
        >
          <template v-if="gradeData.name" #input>
            {{gradeData.name}}
          </template>
        </van-field>
        <van-field
          v-model="formData.title"
          name="title"
          :label="$t('Partner[11][0]')"
          :placeholder="$t('Partner[11][1]')"
          :rules="[{ required: true, message: $t('Partner[11][1]') }]"
          size="large"
        />
        <van-field
          v-model="formData.all_copies"
          name="all_copies"
          :label="$t('Partner[4][0]')"
          :placeholder="$t('Partner[4][1]')"
          :rules="[{ required: true, message: $t('Partner[4][1]') }]"
          size="large"
          readonly
        >
          <template v-if="gradeData.copies" #input>
            <div style="display: flex;flex-wrap: wrap;width:100%">
              <a v-for="item,index in gradeData.copies.split(',')" :key="index" class="radio" :class="{active:item==formData.all_copies}" href="javascript:;" @click="formData.all_copies=item,getMinVal(index)">
                {{$Util.MoneyFormat(item)}}
              </a>
            </div>
          </template>
        </van-field>
        <div v-if="formData.all_copies" class="rate-tips">
          {{$t('Partner[6]')}}: {{InitData.currency}}{{$Util.KeepDecimal(getDiscount(gradeData.amount,gradeData.crowdfunding_discount)/formData.all_copies,2)}}
        </div>
        <van-field
          :value="formData.copies"
          name="copies"
          :label="$t('Partner[5][0]')"
          :placeholder="$t('Partner[5][1]')"
          :rules="[{ required: true, message: $t('Partner[5][1]') }]"
          size="large"
          readonly
        >
          <template #input>
            <van-stepper v-model="formData.copies" integer input-width="60" button-size="36" :min="minVal" :max="formData.all_copies" />
          </template>
        </van-field>
        <div style="padding: 20px 16px">
          <van-button block type="danger" round :color="UserInfo.is_crowdfunding?'var(--color-assist)':''" :disabled="UserInfo.is_crowdfunding?true:false" :loading="isPartner" :loading-text="$t('dialog[2]')" style="font-size: 16px;">{{$t('Partner[7]')}}</van-button>
        </div>
      </van-form>
    </van-action-sheet>
    <van-action-sheet v-model="showGrade" :title="$t('Partner[3][0]')">
      <van-radio-group v-model="radioGrade" checked-color="var(--color-active)">
        <van-cell v-for="item,index in InitData.UserCrowdfundingList" :key="index" :class="`vip-item vip${(index+1)%9}`" :border="false" @click="selectGrade(item)">
          <template #title>
            <div style="display:flex;align-items: center;">
              <img :src="`./static/images/default/vip${(index+1)%9}.png`" height="16" style="margin-right: 5px;">
              {{item.name}}
            </div>
          </template>
          <template #label>
            <span v-html="$t('vip.list.label',{number: item.number})"></span>
            <span>{{$t('vip.list.text[4]')}} {{InitData.currency}}{{$Util.MoneyFormat(item.commission)}}</span>
          </template>
          <template #right-icon>
            <van-radio :name="item.grade" />
          </template>
        </van-cell>
      </van-radio-group>
    </van-action-sheet>
    <van-dialog v-model="showJoin" :title="$t('Partner[2][1]')" show-cancel-button @confirm="joinPartner" @closed="joinForm.copies=1">
      <van-field
        :label="$t('Partner[5][0]')"
        size="large"
        readonly
        input-align="right"
        style="padding: 20px 16px"
      >
        <template #input>
          <van-stepper v-model="joinForm.copies" integer input-width="60" button-size="36" min="1" :max="currPartner.s_copies" />
        </template>
      </van-field>
    </van-dialog>
    <ShareSheet ref="shareDom" shareType="income" shareDan="crowdfunding" :shareOptions="shareOptions" />
    <van-popup v-model="showRule" position="bottom" close-on-popstate closeable style="height:100%">
      <div class="PageBox" style="background-color:transparent">
        <h3 style="position:absolute;top:0;text-align:center;width:100%;font-size:16px;padding: 15px;line-height: 1">{{$t('Partner[10]')}}</h3>
        <div class="ScrollBox" v-html="ruleInfo" style="padding: 15px"></div>
      </div>
    </van-popup>
    <van-popup v-model="showDetail" closeable round class="vip-list" style="width: 90%">
      <div :class="`item vip${(detailInfo.grade-2)%5}`" style="margin:0">
        <span>{{detailInfo.name}}</span>
        <div class="detail">
          <p v-html="$t('vip.list.label',{number: detailInfo.number})"></p>
          <p>{{$t('vip.list.text[4]')}} {{InitData.currency}}{{$Util.MoneyFormat(detailInfo.commission)}}</p>
          <p v-if="detailInfo.grade==UserInfo.vip_level">
            {{$t('vip.user.value[4]')}} {{UserInfo.vip_level==1?`${InitData.setting.memberday}${$t('vip.user.value[3]')}`:$Util.DateFormat('YY-MM-DD',UserInfo.etime)}}
          </p>
          <p v-else>
            {{$t('vip.user.value[0]')}} {{detailInfo.days}}{{$t('vip.user.value[3]')}}
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import ShareSheet from '../share/action.vue'
import videojs from 'video.js'
export default {
  name: 'Video',
  components: {
    ShareSheet
  },
  props: ['tabsActive'],
  data() {
    return {
      taskInfo: '',
      playerOptions: {
        controls: false,
        aspectRatio: '16:9',
        sources: [{
          type: 'video/mp4',
          src: ''
        }]
      },
      fullOptions: {
        controls: false,
        sources: [{
          type: 'video/mp4',
          src: ''
        }]
      },
      showVideo: false,
      countDown: 0,
      intervalTimer: null,
      orderId: '',
      isSubmit: false,
      playStart: false,
      showDown: false,
      rateVal: 5,
      docTitle: document.title,
      downTimer: null,
      isSubmitTask: false,
      showPartner: false,
      partnerActions: this.$t('Partner[2]').flatMap((item,index)=>[{name: item,index: index}]),
      showPartnerAdd: false,
      formData: {
        grade: '',
        title: '',
        all_copies: '',
        copies: 1
      },
      gradeData: {
        name: '',
        copies: ''
      },
      showGrade: false,
      radioGrade: '',
      isPartner: false,
      tabsIndex: 0,
      joinData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsState: 2,
      showJoin: false,
      currPartner: '',
      joinForm: {
        cid: '',
        copies: 1
      },
      myData: '',
      incomeShare: '',
      shareOptions: [],
      minVal: 1,
      showRule: false,
      ruleInfo: '',
      showDetail: false,
      detailInfo: {},
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    fullPlayer() {
      return this.$refs.fullPlayer.player
    },
    gradeInfo() {
      if(this.$store.state.UserInfo.crowdfunding_grade){
        return this.InitData.UserGradeList.find(item=>item.grade==this.$store.state.UserInfo.crowdfunding_grade)
      }else{
        return {
          name: this.$t('Video[0][0]'),
          commission: 0
        }
      }
    }
  },
  watch: {

  },
  created() {
    this.$Model.GetStatisticsInfo()
    this.$Model.GetUserInfo()
    this.getListData()
    this.getShareList()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.intervalTimer)
    clearTimeout(this.downTimer)
  },
  methods: {
    getDiscount(money,discount) {
      if(Number(discount)){
        return this.$Util.MoneyFormat(this.$Util.PointFormat(money) - this.$Util.KeepDecimal(this.$Util.PointFormat(money)*discount,2),true)
      }else{
        return money
      }
    },
    resetForm() {
      this.formData = {
        grade: '',
        title: '',
        all_copies: '',
        copies: 1
      }
      this.minVal = 1
    },
    getMinVal(index) {
      const data = this.gradeData.bi_copies.split(',')
      this.formData.copies = data[index]
      this.minVal = data[index]
    },
    getShareList() {
      this.$Model.GetShareList({shareType:'income',dan:'crowdfunding'},data=>{
        this.incomeShare = data
        this.shareOptions = data.sharelist.flatMap(item=>[{
          name: item.title, 
          icon: this.$store.state.InitData.setting.up_url+item.cover_img, 
          id: item.id,
          is_share: item.is_share,
          reward: item.reward,
          status_dec: item.status_dec
        }])
      })
    },
    submitAllVideo() {
      this.$Model.SubmitAllVideo({type: 'crowdfunding'},data=>{
        if(data.code==1){
          this.getListData()
          this.getShareList()
        }
      })
    },
    changeTabs(name) {
      if(name!=0){
        this.getTabsList()
      }
    },
    joinPartner() {
      this.$Model.JoinPartner(this.joinForm,data=>{
        this.showJoin = false
        if(data.code==1){
          this.getTabsList()
          if(data.state==1){
            this.getListData()
          }
        }
      })
    },
    onLoad() {
      this.getTabsList('load')
    },
    getTabsList(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      if(this.tabsIndex==1){
        this.$Model.GetJoinPartner({state: 2,page_no: this.pageNo},data=>{
          this.isLoad = false
          if(data.code==1){
            if(type=='load'){
              this.joinData = this.joinData.concat(data.list);
            }else{
              this.joinData = data.list
            }
            if(this.pageNo==data.data_total_page){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.isFinished = true
          }
        })
      }
      if(this.tabsIndex==2){
        this.$Model.GetMyPartner({page_no: this.pageNo},data=>{
          this.isLoad = false
          if(data.code==1){
            if(type=='load'){
              this.myData = this.myData.concat(data.list);
            }else{
              this.myData = data.list
            }
            if(this.pageNo==data.data_total_page){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.isFinished = true
          }
        })
      }
    },
    onRefresh() {
      this.getTabsList()
    },
    selectGrade(item) {
      this.gradeData = item
      this.radioGrade = item.grade
      this.formData.grade = item.grade
      this.showGrade = false
    },
    onSubmitAdd(json) {
      this.isPartner = true
      this.$Model.CreatePartner(json,data=>{
        this.isPartner = false
        if(data.code==1){
          this.showPartnerAdd = false
          this.tabsIndex = 2
          this.getTabsList()
          if(data.state==1){
            this.getListData()
          }
        }
      })
    },
    onSelect(item) {
      this.showPartner = false
      if(item.index==0){
        this.showPartnerAdd = true
      }
      if(item.index==1){
        this.$router.push('/joinPartner')
      }
      if(item.index==2){
        this.$router.push('/myPartner')
      }
    },
    clickDown() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        this.$Util.OpenUrl(this.taskInfo.info[0].iosdown)
      }else{
        this.$Util.OpenUrl(this.taskInfo.info[0].appdown)
      }
    },
    getCountDown(){
      this.intervalTimer = setInterval(()=>{
        if(this.countDown>0){
          this.countDown --
        }else{
          if(!this.isSubmitTask){
            this.$Model.SubmitPartner({order_id: this.orderId,status: 3},data=>{
              this.isSubmitTask = true
            })
          }
          clearInterval(this.intervalTimer)
        }
      },1000)
    },
    closeVideo() {
      this.fullPlayer.pause()
    },
    openVideo(full) {
      if(!this.isSubmit&&!this.playStart){
        this.isSubmit = true
        if(this.taskInfo.my_s_day_number==0){
          this.isSubmit = false
          // if(full){
          //   this.showVideo = true
          // }else{
          //   this.player.play()
          // }
        }else{
          this.$Model.ReceivePartner({id:this.taskInfo.info[0].task_id},data=>{
            this.isSubmit = false
            if(data.code==1){
              this.orderId = data.order_id
              if(full){
                this.showVideo = true
              }else{
                this.player.play()
              }
            }else{
              this.orderId = ''
            }
          })
        }
      }
    },
    openedVideo() {
      this.fullPlayer.play()
    },
    getListData(player) {
      clearInterval(this.intervalTimer)
      clearTimeout(this.downTimer)
      this.countDown = 0
      this.showDown = false
      this.playerOptions.sources[0].src = this.taskInfo.company_video
      this.fullOptions.sources[0].src = this.taskInfo.company_video
      this.$Model.GetPartnerList({task_level: this.$store.state.UserInfo.crowdfunding_grade},data=>{
        if(data.code==1){
          this.taskInfo = data
          if(data.my_s_day_number==0){
            this.playerOptions.sources[0].src = this.taskInfo.company_video
            this.fullOptions.sources[0].src = this.taskInfo.company_video
          }else{
            this.playerOptions.sources[0].src = this.taskInfo.info[0].link_info
            this.fullOptions.sources[0].src = this.taskInfo.info[0].link_info
            this.countDown = this.taskInfo.info[0].task_second
          }
        }
        if(player){
          player.currentTime(0)
          player.trigger('loadstart')
        }
      })
    },
    playerReadied(player) {
      console.log('player readied',player)
      const BigPlayButton = videojs.getComponent('BigPlayButton')
      videojs.registerComponent('BigPlayButton', videojs.extend(BigPlayButton, {
        handleClick: (event)=>{
          if(this.$store.state.UserInfo){
            this.openVideo(false)
          }else{
            this.$router.push('/login')
          }
        }
      }))
      player.addChild('BigPlayButton');
    },
    onPlayerPlay(player) {
      console.log('player play!', player)
      if(this.countDown){
        this.playStart = true
        this.getCountDown()
      }
      if(this.taskInfo.info[0].isdown==1){
        this.downTimer = setTimeout(()=>{
          this.showDown = true
        },this.taskInfo.info[0].downtime*1000)
      }
    },
    onPlayerPause(player) {
      console.log('player pause!', player)
      this.playStart = false
      if(!this.isSubmitTask){
        this.$Model.SubmitTask({order_id: this.orderId,status: 3},data=>{
          this.isSubmitTask = false
        })
      }else{
        this.isSubmitTask = false
      }
      this.getListData(player)
    },
    onPlayerEnded(player) {
      console.log('player ended!', player)
      this.playStart = false
    },
  }
}
</script>
<style scoped>
.box-bg {
  background: linear-gradient(#efe6e3,#fff);
}
.user-grade {
  margin: 10px 20px;
  color: #fff;
  line-height: 1;
  position: relative;
}
.user-grade .bg{
  background-image: url('../../../public/static/images/default/task_bg.png'),linear-gradient(to right,#f83a3a,#fba030);
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 25px 15px;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}
.user-grade .left{
  font-size: 24px;
}
.user-grade .left p{
  font-size: 12px;
  margin-top: 8px;
}
.user-grade .line{
  height: 6px;
  background-color: #d1d1d1;
  border-radius: 10px;
  position: absolute;
  left: -5px;
  right: -5px;
  bottom: -2px;
}
.van-cell-group__title{
  font-size: 15px;
  font-weight: 600;
}
.income .van-cell__title{
  font-size: 30px;
  color: var(--color-important);
}
.income .van-cell__title small{
  font-size: 12px;
  color: var(--color-main);
  margin-left: 5px;
}
.task-item{
  margin: 15px;
  line-height: 1;
}
.task-item .info{
  background-color: var(--background-box);
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
}
.task-item .progress{
  margin-bottom: 15px;
}
.task-item .progress .flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.task-item .progress .flex b{
  font-size: 15px;
}
.task-item .van-progress{
  margin: 8px 0;
}
.count-down{
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: rgba(0, 0, 0, .5);
  border-radius: 50px;
  min-width: 30px;
  height: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 1px #fff solid;
  color: #fff;
  z-index: 3000;
}
.video{
  position: relative;
}
.down-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 99;
}
.down-popup {
  width: 25%;
  right: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  line-height: 1;
  height: 60%;
  position: absolute;
  overflow: hidden;
}
.down-popup>a{
  display: block;
  height: 100%;
}
.down-popup h4{
  margin: 10px 0;
  font-weight: 600;
  font-size: 12px;
}
.down-popup .rate{
  color: #ffd21e;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 12px;
}
.down-popup .rate span{
  margin-right: 3px;
}
.vip-item{
  border-radius: 15px;
  padding: 16px;
  margin: 0 15px 15px;
  width: auto;
}
.vip-item .van-cell__title{
  font-size: 16px;
}
.vip-item .van-cell__label{
  line-height: 1;
  margin-top: 8px;
}
.vip-item .van-cell__label span{
  margin-right: 15px;
}
.vip-item>>>.van-radio__icon .van-icon{
  background-color: var(--background-main);
  border-color: var(--color-assist);
}
.radio {
  color: var(--color-assist);
  border-radius: 3px;
  padding: 8px 10px;
  line-height: 1;
  font-size: 14px;
  min-width: 29%;
  margin: 5px 10px 5px 0;
  text-align: center;
  border: 1px solid var(--border-color-main);
}
.radio.active{
  color: var(--color-white);
  background-color: var(--color-active);
  border-color: var(--color-active);
}
.van-field>>>.van-field__label{
  font-weight: 600;
}
.rate-tips{
  color: var(--color-assist);
  padding: 10px 16px;
  font-size: 12px;
}
.van-uploader{
  display: block;
  margin-top: 10px;
}
.van-uploader>>>.van-uploader__upload-icon{
  font-size: 16px;
}
.van-uploader>>>.van-uploader__wrapper{
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview-image{
  width: 36px;
  height: 36px;
  margin-right: 0;
  border-radius: 5px;
}
.van-uploader>>>.van-uploader__preview{
  margin-right: 0;
  border-radius: 5px;
  overflow: hidden;
}
.van-uploader>>>.van-uploader__mask-message{
  white-space: nowrap;
}
.van-pull-refresh{
  min-height: calc(100vh - 90px);
}
.van-list>>>.item{
  margin: 10px 0;
  border-radius: 10px;
  padding: 15px;
  background-color: var(--background-box);
}
.van-list>>>.item .van-cell__title{
  font-size: 15px;
}
.van-list>>>.item .van-cell__label{
  line-height: 1;
  margin-top: 8px;
}
.van-list>>>.item .van-cell__label p{
  margin-top: 8px;
}
.van-list>>>.item .right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}
.van-list>>>.item .right .price{
  text-align: right;
  margin-bottom: 18px;
}
.van-list>>>.item .right .price b{
  color: var(--color-active);
  font-size: 16px;
  margin-top: 5px;
  display: block;
}
.van-list>>>.item .right .van-button{
  margin-left: 5px;
}
.van-list>>>.item .right .state{
  position: absolute;
  top: 20px;
  right: 25%;
  height: 80px;
}
.partner-tabs{
  margin-top: 20px;
}
.partner-tabs>>>.van-tabs__nav{
  padding-left: 0;
  padding-right: 0;
}
.vip-list .item{
  background-size: 80%,100%;
  background-position: 70% 0;
  margin: 15px 0;
  border-radius: 10px;
  line-height: 1;
  overflow: hidden;
  color: #fff;
}
.vip-list .item>span{
  display: inline-block;
  padding: 5px 10px;
  border-radius: 0 0 5px 0;
  background-color: rgba(0, 0, 0, .3);
  font-size: 14px;
}
.vip-list .item>h3{
  font-size: 15px;
  padding: 0 15px;
  margin-top: 15px;
}
.vip-list .item .grid{
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  text-align: center;
  margin-top: 15px;
}
.vip-list .item .grid>div{
  font-size: 16px;
}
.vip-list .item .grid>div p{
  font-size: 12px;
  margin-top: 5px;
}
.vip-list .item .bottom{
  border-top: 1px solid rgba(255, 255, 255, .2);
  padding: 10px 15px;
  margin-top: 15px;
  display: flex;
  align-items: center;
}
.vip-list .item .bottom .money{
  flex: 1;
}
.vip-list .item .bottom .money b{
  color: #ec1d23;
}
.vip-list .item .bottom .money a{
  color: #635e5a;
  margin-left: 10px;
  font-size: 12px;
}
.vip-list .item .bottom .btn{
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}
.vip-list .item .bottom .van-button{
  color: #59280d!important;
  box-shadow: 0 0 5px rgba(0, 0, 0, .1);
  margin-left: 0;
}
.vip-list .item .detail{
  padding: 20px;
  font-size: 15px;
}
.vip-list .item .detail p+p{
  margin-top: 15px;
}
.vip-list .item .detail>>>b{
  font-size: 18px;
  margin: 0 8px;
  color: #ec1d23;
}
.vip-list>>>.van-popup__close-icon{
  color: #fff;
  top: 10px;
  right: 10px;
}
.vip0 {
  background: url('../../../public/static/images/default/vip_bg0.png') no-repeat,linear-gradient(to right,#aebbd1,#768ca8);
  
}
.vip1 {
  background: url('../../../public/static/images/default/vip_bg1.png') no-repeat,linear-gradient(to right,#e9ceaf,#dbb897);
}
.vip2 {
  background: url('../../../public/static/images/default/vip_bg2.png') no-repeat,linear-gradient(to right,#c8ddf2,#a7c4e1);
}
.vip3 {
  background: url('../../../public/static/images/default/vip_bg3.png') no-repeat,linear-gradient(to right,#f4d6a0,#e3b468);
}
.vip4 {
  background: url('../../../public/static/images/default/vip_bg4.png') no-repeat,linear-gradient(to right,#aeaad3,#8e8cc3);
}
</style>